module.exports = __webpack_public_path__ + "img/americano.1c2761f3.png";